import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { GET_COMP_STATEMENT_PAY_GROUP } from "src/api-setup/api-endpoints";

/*
 * Per-pay-group earned / projected breakdown for one period - the rows under
 * the Earnings Overview chart. Ported from useSelectPayGroup in the mobile app.
 *
 * Rows: { pay_group_mstr_key, pay_group_name, pay_group_type, earned_value,
 *         projected_value, comp_plan_master_key, task_category_mstr_key,
 *         period_type, ... }
 */
export const getCompStatementPayGroup = async (
  cookiesData,
  dispatch,
  providerId,
  periodKey,
  projectedValue = 0,
) => {
  if (!cookiesData || !providerId || !periodKey) return [];

  try {
    const apiHeaders = generateHeader();
    const requestBody = {
      in_provider_mstr_key: providerId,
      in_period_mstr_key: Number(periodKey),
      in_projected_val: projectedValue,
    };

    const response = await POSTAPI(false, GET_COMP_STATEMENT_PAY_GROUP, null, apiHeaders, requestBody, dispatch);
    const rowResult = response?.data?.row_result;

    return Array.isArray(rowResult) ? rowResult : [];
  } catch (error) {
    console.error("Error fetching comp statement pay groups:", error);
    return [];
  }
};
